import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

const TranslateService = {
    translate: async (text, sourceLanguage, targetLanguage) => {
        try {
            const requestBody = {
                text: text,
                sourceLanguage: sourceLanguage,
                targetLanguage: targetLanguage
            };

            const result = await ApiService.postData("/v1/dic/translate", requestBody);
            
            if (result && result.code === "FAILURE") {
                throw new Error(result.message || "Translation failed");
            }

            return result;
        } catch (error) {
            Logger.error(`Error translating text "${text}":`, error);
            throw error;
        }
    }
};

export default TranslateService;

